/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import FormFieldEditor from '../helpers/FormFieldEditor';
import { Checkbox, TextInput, Text } from '../../../uiold';
import Infotip from '../../../uiold/Infotip';
import { Addon } from '../../../../types/shared/Addon';

import AddonElement from '../AddonElement';

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValue: (key: string, newValue: unknown) => void;
  renderNameInput: () => ReactElement;
  renderLabelInput: () => ReactElement;
  addons?: Map<string, Addon> | null | undefined;
};

function EditorView(props: EditorViewProps) {
  let { data, updateValue, renderNameInput, renderLabelInput, addons } = props;
  let addon = addons?.get(data?.id as string);
  return (
    <View>
      {renderNameInput()}
      {renderLabelInput()}
      {addon && (
        <>
          <View style={styles.textInput}>
            <Text style={styles.label}>Linked Addon</Text>
            <Infotip
              width={150}
              text="Name of Addon this question is linked to. Go to the Addons page to update pricing."
            />
          </View>
          <TextInput
            style={{ marginBottom: 8 }}
            disabled
            defaultValue={addon.name}
          />
        </>
      )}
      <Checkbox
        text="Required"
        isChecked={!!data.is_required}
        onChange={(value) => updateValue('is_required', value)}
      />
      <Checkbox
        text="Disable 'select all'"
        isChecked={!!data.disableSelectAll}
        onChange={(value) => updateValue('disableSelectAll', value)}
      />
    </View>
  );
}

type Props = {
  parent: AddonElement;
  addons?: Map<string, Addon> | null | undefined;
};

class AddonElementFieldEditorView extends Component<Props> {
  render() {
    let { parent, addons } = this.props;

    return (
      <FormFieldEditor component={EditorView} parent={parent} addons={addons} />
    );
  }
}

let styles = StyleSheet.create({
  textInput: {
    flexDirection: 'row',
    marginVertical: 5,
    zIndex: 1,
  },
  label: {
    fontWeight: 'normal',
  },
});

export default AddonElementFieldEditorView;
